export enum LoaderType {
    Page = 'page',
    Section = 'section'
}
